// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1s7Pb","overflowing":"ReadFullNote_overflowing__HLUMA"};